/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const LinkMedium = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m17.66 14.83-1.42-1.42L17.66 12A4 4 0 1 0 12 6.34l-1.41 1.42-1.42-1.42 1.42-1.41a6 6 0 0 1 8.48 8.48zm-2.83 2.83-1.42 1.41a6 6 0 0 1-8.48-8.48l1.41-1.42 1.42 1.42L6.34 12A4 4 0 0 0 12 17.66l1.41-1.42zm0-9.9 1.41 1.41-7.07 7.07-1.41-1.41z" />
  </Icon>
);
